export default "__VITE_ASSET__79431ade__"